'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  /* mobile\n   * encapsulating div with padding\n   * */\n  padding: 1em;\n\n  /* desktop\n   * full sized transparent background\n   * */\n  @media (min-width: 600px) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 12;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(16,33,49,0.9);\n    padding: 0;\n  }\n'], ['\n  /* mobile\n   * encapsulating div with padding\n   * */\n  padding: 1em;\n\n  /* desktop\n   * full sized transparent background\n   * */\n  @media (min-width: 600px) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 12;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(16,33,49,0.9);\n    padding: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  /* mobile\n   * */\n  width: 100%;\n  background: #F6F9FD;\n  box-shadow: ', ';\n  border-radius: 4px;\n  overflow: hidden;\n\n  /* desktop\n   * centered container\n   * */\n  @media (min-width: 600px) {\n    width: auto;\n  }\n'], ['\n  /* mobile\n   * */\n  width: 100%;\n  background: #F6F9FD;\n  box-shadow: ', ';\n  border-radius: 4px;\n  overflow: hidden;\n\n  /* desktop\n   * centered container\n   * */\n  @media (min-width: 600px) {\n    width: auto;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sharedStyles = require('../sharedStyles');

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var Background = _styledComponents2.default.div(_templateObject);

var Wrap = _styledComponents2.default.div(_templateObject2, _sharedStyles.glow);

var Wrapper = (0, _reactOnclickoutside2.default)(Wrap);

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Modal.prototype.componentDidMount = function componentDidMount() {
    if (this.props.disableBodyScroll && document.documentElement.clientWidth > 600) {
      document.querySelector('body').style.overflow = 'hidden';
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    document.querySelector('body').style.overflow = 'auto';
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$onClose = _props.onClose,
        onClose = _props$onClose === undefined ? function () {} : _props$onClose,
        props = _objectWithoutProperties(_props, ['children', 'onClose']);

    return _react2.default.createElement(
      Background,
      null,
      _react2.default.createElement(
        Wrapper,
        _extends({}, props, { handleClickOutside: onClose }),
        children
      )
    );
  };

  return Modal;
}(_react.Component);

exports.default = Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/Modal/index.js
// module id = 103
// module chunks = 2